import React, {memo, useMemo} from "react";
import PropTypes from "prop-types";
import StatDisplay from "../../Containers/statDisplay";
import {DEFAULT_LINE_COLORS} from "../../Helpers/graphColorPalette";

/** This component will generate Plot of type SingleStat.
 */

const SingleStat = (props) => {
  const {jsonData, properties} = props;
  const {colors, line_keys: lines = []} = properties;

  const statValue = useMemo(() => {
    const STAT_KEY = lines.length > 0 ? lines[0].key : "_value";
    return jsonData.length > 0 ? jsonData[jsonData.length - 1][STAT_KEY] : undefined;
  }, [jsonData, lines]);

  const colorHexes = useMemo(() => {
    if (colors && colors.length) {
      return colors.map((color) => color.hex);
    }
    return DEFAULT_LINE_COLORS.map((color) => color.hex);
  }, [colors]);

  return (
    <div className="h-100 position-relative w-100 ">
      {statValue && <StatDisplay color={colorHexes[0]} text={statValue} />}
    </div>
  );
};

SingleStat.propTypes = {
  properties: PropTypes.object.isRequired,
  jsonData: PropTypes.array.isRequired,
};

export default memo(SingleStat);
